import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1)
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    scrollBarB: {
      float: 'left',
      height: '300px',
      width: '65px',
      // background: '#F5F5F5',
      overflowY: 'scroll'
    },
    scrollBarC: {
      float: 'left',
      height: '480px',
      width: '65px',
      // background: '#F5F5F5',
      overflowY: 'scroll',
      overflowX: 'hidden'
    },
    root: {
      '&::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        backgroundColor: '#F5F5F5',
        borderRadius: '10px'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        backgroundImage:
          '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
      }
    },
    textColor: { color: '#1769aa', fontWeight: 600 },
    button: {
      marginLeft: 10,
      marginTop: 10
    }
  })
)
